import React from "react";
import { Mic } from "lucide-react";
import { useAppStore } from "@/hooks/useAppStore";
import { useTranslation } from "@/lib/translate";

interface VADModeToggleProps {
  className?: string;
  onToggle?: (enabled: boolean) => void;
}

export const VADModeToggle: React.FC<VADModeToggleProps> = ({ onToggle }) => {
  const isVADEnabled = useAppStore((state) => state.isVADEnabled);
  const toggleVAD = useAppStore((state) => state.toggleVAD);
  const preferredLanguage = useAppStore((state) => state.preferredLanguage);
  const t = useTranslation(preferredLanguage);

  return (
    <button
      onClick={() => {
        toggleVAD();
        onToggle?.(!isVADEnabled);
      }}
      title={isVADEnabled ? t("Disable Voice Detection") : t("Enable Voice Detection")}
      style={{
        minWidth: '220px',
        whiteSpace: 'nowrap',
        padding: '18px 20px',
        background: isVADEnabled ? '#00838F' : '#00ACC1',
        border: 'none',
        borderRadius: '50px',
        color: '#fff',
        fontSize: '16px',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
        boxShadow: '0 8px 24px rgba(0, 172, 193, 0.4)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#26C6DA';
        e.currentTarget.style.transform = 'scale(1.02)';
        e.currentTarget.style.boxShadow = '0 12px 32px rgba(0, 172, 193, 0.5)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = isVADEnabled ? '#00838F' : '#00ACC1';
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 172, 193, 0.4)';
      }}
      onMouseDown={(e) => {
        e.currentTarget.style.transform = 'scale(0.98)';
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = 'scale(1.02)';
      }}
    >
      <Mic className="h-5 w-5" color="white" />
      <span>{t('Auto Mode')}</span>
    </button>
  );
};
